import React from 'react';
import './PhoneInfoBox.css';

const PhoneInfoBox = ({ number, message, side, style }) => {
    return (
        <div className="phoneInfoBox" style={style}>
            <div className="message" style={{marginLeft: side==='left' && '15px',marginRight: side==='right' && '15px'}}>{message}</div>
            <div className={`circle ${side === 'right' ? 'right' : 'left'}`}>
                {number}
            </div>
        </div>
    );
};

export default PhoneInfoBox;
